<template>
  <div :class="['o-feed-section-loading',
    $store.getters.getAcademyData.persona === undefined
      ? 'o-feed-section-loading-upgrade' : '']">
    <MoleculeFeedSectionLoading/>
  </div>
</template>

<script>
export default {
  name: 'OrganismFeedSectionLoading',

  components: {
    MoleculeFeedSectionLoading: () => import('@/components/molecules/MoleculeFeedSectionLoading')
  }
}
</script>
